import { HtmlHeadInclude } from '@msdyn365-commerce/core-internal';
import * as React from 'react';

export default (props: any) => {
    const { inlineScript, defer, async, crossorigin, noscriptContent, externalScript } = props.config;

    return (
        <HtmlHeadInclude>
            {/* External script passed as raw HTML string */}
            {externalScript && <div dangerouslySetInnerHTML={{ __html: externalScript }} />}

            {/* Inline script */}
            <script
                data-load-point='headStart'
                dangerouslySetInnerHTML={{ __html: inlineScript }}
                defer={defer}
                async={async}
                crossOrigin={crossorigin}
            />

            {/* noscript tag */}
            {noscriptContent && <noscript dangerouslySetInnerHTML={{ __html: noscriptContent }} />}
        </HtmlHeadInclude>
    );
};
